import { render, staticRenderFns } from "./newLocation.vue?vue&type=template&id=8adfd19c&scoped=true&"
import script from "./newLocation.vue?vue&type=script&lang=ts&"
export * from "./newLocation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8adfd19c",
  null
  
)

export default component.exports